import { type ComponentPropsWithRef, useEffect, useRef } from 'react';
import { type Checkbox as RadixCheckbox } from 'radix-ui';
import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';

export const IndeterminateCheckbox = ({
  indeterminate,
  id,
  checkboxContainerClassName,
  ...rest
}: { indeterminate?: boolean; checkboxContainerClassName?: string } & ComponentPropsWithRef<typeof Checkbox>) => {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return (
    <div ref={ref} className={cn('flex', checkboxContainerClassName)}>
      <Checkbox
        // Forwarded so a visible <Label htmlFor> can own the accessible name and the click target.
        id={id}
        data-cy={`checkbox-row-id-${id}`}
        onCheckedChange={rest.onChange as unknown as (checked: RadixCheckbox.CheckedState) => void}
        disabled={rest.disabled}
        {...rest}
        className={cn('rounded-xs ring-2! ring-icon-base! icon-4! text-text-icon-base!', rest.className)}
        checked={indeterminate ? 'indeterminate' : rest.checked}
      />
    </div>
  );
};
